import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import { Button } from "primereact/button";
import EzTable from "../../common/EzTable";
import { EzToast, TOAST_SEVERITY } from "../../common/EzToast";
import EzNotFound from "../../common/EzNotFound";
import CreateCustomerComponent from "./CreateCustomer";

const getIconPath = (imgPathDelta = "/no-record.png") =>
  process.env.PUBLIC_URL + imgPathDelta;
const CustomerMarkupComponent = (props) => {
  const {
    tableData,
    paginationInfo,
    screenPermissions,
    isPageLevelError,
    fetchCustomerMarkup,
    isLoading,
    editCustomerMarkups,
    addCustomerMarkup,
    isEditCustomerMarkupSuccess,
    isEditCustomerMarkupError,
    isCreateCustomerMarkupSuccess,
    isCreateCustomerMarkupError,
    fuelCompanyProviderDD,
    fetchFuelCompanyProviderDD,
    fuelCustomerCompanynNameProviderDD,
    fetchFuelCustomerCompanyNameProviderDD,
  } = props;

  const [areFiltersVisible, toggleFilterState] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedCustomerMarkup, setSelectedCustomerMarkup] = useState(null);
  const [companyNameProviderDD, setCompanyNameProviderDD] = useState([]);

  const editCustomerMarkup = (data) => {
    console.log("BJ", data);
    fetchFuelCompanyProviderDD();
    setSelectedCustomerMarkup(data);
    setShowModal(true);
  };

  const handleAddMarkup = () => {
    fetchFuelCompanyProviderDD();
    setSelectedCustomerMarkup(null);
    setShowModal(true);
  };

  useEffect(() => {
    fetchFuelCompanyProviderDD();
    fetchFuelCustomerCompanyNameProviderDD();
    if (isEditCustomerMarkupSuccess || isCreateCustomerMarkupSuccess) {
      fetchCustomerMarkup();
    }
  }, [isEditCustomerMarkupSuccess, isCreateCustomerMarkupSuccess]);

  const fetchCustomerMarkupLazy = (props) => {
    fetchCustomerMarkup(props);
  };

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative">
        <div
          className=""
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div className="ml-3">
              <h4>Customer Markup</h4>
            </div>
            <Button
              label={areFiltersVisible ? "Advanced Filter" : "Advanced Filter"}
              icon={areFiltersVisible ? "pi pi-filter-slash" : "pi pi-filter"}
              className={`p-button-text p-button-secondary`}
              onClick={() => {
                toggleFilterState(!areFiltersVisible);
              }}
            />
          </div>
          {screenPermissions?.create && (
            <Button
              tooltip={"Add Markup"}
              tooltipOptions={{ position: "left" }}
              label={"Add Markup"}
              // icon={"pi pi-arrow-left"}
              className={`p-button `}
              onClick={handleAddMarkup}
            />
          )}
        </div>
      </div>
    );
  };
  const shouldRenderFullPageError = () => isPageLevelError;
  const shouldRenderManageCardRecords = () => tableData?.columns?.length > 0;
  const shouldRenderNotFoundView = () =>
    !shouldRenderManageCardRecords() && !shouldRenderFullPageError();

  const filters = {
    global: { value: null },
    customer_id: { filterKey: "customer_id", value: null },
    company_name: { filterKey: "company_name", value: null },
    mark_up_value: { filterKey: "mark_up_value", value: null },
    fuel_company_provider: { filterKey: "fuel_company_provider", value: null },
  };

  const tableProps = {
    areFiltersVisible,
    columns: tableData?.columns,
    paginationInfo,
    screenPermissions,
    showViewButton: false,
    value: tableData?.rows,
    emptyMessage: "No Customer Markup found.",
    filters,
    sortField: null,
    loading: isLoading,
    showMoreActions: false,
    onEditRecord: editCustomerMarkup,
    isMarkup: true,
    loadLazyData: fetchCustomerMarkupLazy,
  };
  const getToastProps = () => {
    if (isEditCustomerMarkupSuccess) {
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle: "Customer Markup Updated Successfully",
        shouldShowToast: true,
      };
    }

    if (isEditCustomerMarkupError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle: "Error while updating markup",
        shouldShowToast: true,
      };
    }

    if (isCreateCustomerMarkupSuccess) {
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle: "Customer Markup Created Successfully",
        shouldShowToast: true,
      };
    }

    if (isCreateCustomerMarkupError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle: "Error while creating markup",
        shouldShowToast: true,
      };
    }

    return { shouldShowToast: false };
  };

  return (
    <>
      <div className="paddingbox">
        <EzToast {...getToastProps()} />
        <div className="containerbox">
          {renderPageHeaderSection()}
          <div className="mTop15">
            {shouldRenderFullPageError() && (
              <EzNotFound
                messageStyle={{ marginLeft: "-70px" }}
                bgImgUrl={getIconPath("something-broke.png")}
                message={"Oops! Something broke, we are working on a fix."}
              />
            )}
            {shouldRenderManageCardRecords() && (
              <Row>
                <Col md={12}>
                  <EzTable {...tableProps} />
                </Col>
              </Row>
            )}
            {shouldRenderNotFoundView() && (
              <EzNotFound
                bgImgUrl={getIconPath()}
                message={"No Comapny records to show"}
              />
            )}
          </div>
        </div>
      </div>

      <CreateCustomerComponent
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        fuelCustomerCompanynNameProviderDD={fuelCustomerCompanynNameProviderDD}
        editCustomerMarkups={editCustomerMarkups}
        addCustomerMarkup={addCustomerMarkup}
        data={selectedCustomerMarkup}
        fuelCompanyProviderDD={fuelCompanyProviderDD}
        title={
          selectedCustomerMarkup
            ? "Update Customer Markup"
            : "Add Customer Markup"
        }
        mode={selectedCustomerMarkup ? "edit" : "create"}
      />
      {/* <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateCustomerComponent
          editCustomers={editCustomers}
            customerData={selectedCustomer}
           // fuelCompanyProviderDD={fuelCompanyProviderDD}
            onClose={() => setShowModal(false)}
          />
        </Modal.Body>
      </Modal> */}
    </>
  );
};
export default CustomerMarkupComponent;
